var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHivits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 91,
    viewBox: "0 0 224 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_2741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.595 84.9648C181.988 80.9454 180.185 74.4598 180.185 65.5199V56.7815H197.768V67.9031C197.768 72.3375 199.192 74.5547 202.039 74.5547C203.629 74.5547 204.744 74.0922 205.373 73.1556C206.002 72.2189 206.31 70.6419 206.31 68.4247C206.31 65.508 205.966 63.1011 205.266 61.1922C204.578 59.2833 203.688 57.6945 202.608 56.4139C201.529 55.1334 199.607 53.1415 196.831 50.4382L189.131 42.7432C183.163 36.9216 180.185 30.4715 180.185 23.4049C180.185 15.7811 181.941 9.97133 185.441 5.98748C188.941 2.00364 194.054 0.0117188 200.793 0.0117188C208.837 0.0117188 214.639 2.14592 218.175 6.40247C221.71 10.6709 221.947 17.6307 221.947 26.713H205.088L205.171 20.2866C205.171 19.1128 204.839 18.1761 204.186 17.4766C203.522 16.7889 202.608 16.4332 201.434 16.4332C200.046 16.4332 199.002 16.8126 198.314 17.5715C197.614 18.3303 197.27 19.3737 197.27 20.6898C197.27 23.6065 198.931 26.6181 202.264 29.7364L212.67 39.7197C215.102 42.0792 217.107 44.3083 218.708 46.4306C220.298 48.5411 221.592 51.0429 222.553 53.924C223.525 56.8052 224.012 60.2199 224.012 64.1682C224.012 72.9777 222.398 79.6412 219.171 84.1823C215.944 88.7234 210.617 90.988 203.202 90.988C195.086 90.988 189.225 88.9724 185.619 84.953L185.595 84.9648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.175 90.1578V0.82959H137.449V90.1578H120.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.453 90.1578V17.9862H139.834V0.82959H178.963V17.9862H168.344V90.1578H150.441H150.453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7678 0.82959L98.7237 15.2829L97.3712 29.5346L94.0491 77.0087H93.2068L89.2559 29.5346L87.9034 15.2829L86.6576 0.82959H69.6915L78.222 90.1578H108.512L117.149 0.82959H99.7678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.122 0L46.1407 7.37485H58.1593L60.1407 0H48.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0881 35.9613H35.0475L44.7169 0H32.7458L29.2932 12.7222H18.1763L21.6288 0H9.65763L0 35.9613H11.9593L15.4119 23.0257H26.5407L23.0881 35.9613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2695 35.9615L57.3525 9.47363H45.7492L38.6661 35.9615H50.2695Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_2741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 91,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHivits);
export default __webpack_public_path__ + "static/media/logo_hivits.4b87892a427d9ff92e7d5a145c34864d.svg";
export { ForwardRef as ReactComponent };